<template>
  <b-container fluid class="gradient">
    <b-row align-h="center" class="full-height">
      <b-col md="6" lg="4" align-self="center">
        <b-card>
          <div class="text-center">
            <img class="logo" src="/img/new-logo.svg" />
          </div>

          <p class="card-text text-sm-center">
            We think you will be amazed how simple it is to deploy and manage virtual networks with us.
          </p>

          <b-form class="form">
            <b-alert variant="danger" class="text-center" :show="signupError">Couldn't register this account</b-alert>

            <b-form-group :invalid-feedback="emailError" :state="hasEmailError">
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="at" />
                </b-input-group-text>
                <b-form-input
                  name="email"
                  v-focus
                  size="lg"
                  required
                  :state="hasEmailError"
                  v-model.trim="form.email"
                  placeholder="Email"
                  @keyup.native.enter="signup"
                  type="text"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group :invalid-feedback="passwordError" :state="hasPasswordError">
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="lock" />
                </b-input-group-text>
                <b-form-input
                  size="lg"
                  name="password"
                  ref="password"
                  required
                  v-validate="'required|min:8'"
                  v-model.trim="form.password"
                  :state="hasPasswordError"
                  placeholder="Password"
                  @keyup.native.enter="signup"
                  type="password"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group :invalid-feedback="confirmError" :state="hasConfirmError">
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="check-double" />
                </b-input-group-text>
                <b-form-input
                  size="lg"
                  name="confirm"
                  required
                  data-vv-as="password"
                  v-validate="'required|confirmed:password'"
                  v-model.trim="form.confirm"
                  :state="hasConfirmError"
                  placeholder="Confirm password"
                  @keyup.native.enter="signup"
                  type="password"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <b-button size="lg" block variant="primary" @click="signup" :disabled="hasErrors">
                <strong>Register</strong>
              </b-button>
            </b-form-group>
          </b-form>

          <b-row slot="footer">
            <b-col class="text-center">
              Have an account?
              <router-link :to="{ name: 'login' }">Login</router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script type="text/javascript">
import { pick } from 'lodash/object'

const DEFAULT = {
  email: '',
  password: '',
  confirm: ''
}

export default {
  computed: {
    hasEmailError() {
      return this.fieldBag.email && this.fieldBag.email.dirty ? this.fieldBag.email.valid : null
    },
    emailError() {
      return this.errors.has('email') ? this.errors.first('email') : ''
    },
    hasPasswordError() {
      return this.fieldBag.password && this.fieldBag.password.dirty ? this.fieldBag.password.valid : null
    },
    passwordError() {
      return this.errors.has('password') ? this.errors.first('password') : ''
    },
    hasConfirmError() {
      return this.fieldBag.confirm && this.fieldBag.confirm.dirty ? this.fieldBag.confirm.valid : null
    },
    confirmError() {
      return this.errors.has('confirm') ? this.errors.first('confirm') : ''
    },
    hasErrors() {
      return this.errors.any()
    }
  },

  data: () => ({
    form: { ...DEFAULT },
    signupError: false
  }),

  methods: {
    clearForm() {
      this.form = { ...DEFAULT }
    },
    signup() {
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            let creds = pick(this.form, ['email', 'password'])
            this.$store
              .dispatch('signup', creds)
              .then(() => {
                this.$router.push({ name: 'dashboard' })
              })
              .catch(() => {
                this.signupError = true
              })
          } else {
            this.$validator.flag('email', { dirty: true })
            this.$validator.flag('password', { dirty: true })
            this.$validator.flag('confirm', { dirty: true })
          }
        })
        .catch(() => {
          // console.log(e)
          // console.log(this.errors)
        })
    }
  }
}
</script>
